/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    WineProductInstanceNewTastingNoteDto,
    WineProductInstanceTastingNoteDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class WineTastingNoteControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        createNewTastingNote(
                    wineProductInstanceId: number
                    , 
                    
                    requestBody: WineProductInstanceNewTastingNoteDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/note/${wineProductInstanceId}`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        deleteById(
                    id: number
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/note/${id}`;

            return this._httpClient.delete<number>(url, requestOptions);
    }


        getAllTastingNotesByWineProductInstance(
                    wineProductInstanceId: number
    ): Observable<Array<WineProductInstanceTastingNoteDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/note/${wineProductInstanceId}`;

            return this._httpClient.get<Array<WineProductInstanceTastingNoteDto>>(url, requestOptions);
    }


        getTastingNoteByLoggedUserAndWineProductInstance(
                    wineProductInstanceId: number
    ): Observable<WineProductInstanceTastingNoteDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/note/${wineProductInstanceId}/user`;

            return this._httpClient.get<WineProductInstanceTastingNoteDto>(url, requestOptions);
    }


}

